import React from 'react';
import {getDadosFixosCertificado, salvarDadosCertificado, atualizarDadosCertificado, downloadModeloCertificado}  from '../../actions/FormBuilderActions'
import { buscarFormulario } from '../../actions/FormActions';
import {View, InputField, SelectField, ButtonFields, Card, Fields, RichTextEditor, UploadCroppedImage, Message} from 'react-template';
import update from "immutability-helper";
import $ from 'jquery'
import {downloadFileLink} from "../../../../helpers/Downloads"

import "../../../../assets/css/view/formulario/list/tabs/formCertifielData.css"
import "../../../../assets/css/components/elements/RichTextEditor.css"

export default class NovoModeloCertificado extends View {
    formatosCertificado = [
        {key: "portrait", value: "portrait", text: "Vertical"},
        {key: "landscape", value: "landscape", text: "Horizontal"}
    ]

    certificadoRatio = {
        portrait: {x: 210, y: 297},
        landscape: {x: 297, y: 210}
    }

    constructor(props){
        super(props);

        this.onChangeOptions = this.onChangeOptions.bind(this);
        this.onChangeFormatoCertificado = this.onChangeFormatoCertificado.bind(this);
        this.state = {
            idFormulario: this.props.params.id,
            idCampo: null,
            certificado: {
                tituloModelo: '',
                formato: "landscape",
                bgImagem: "",
                conteudo: ""
            },
            bgFundo64: null,
            itensFormCertificado: []
        };
        this.selected = false;
        this.novoDadoCertificado = false;
        this.options = []
    }

    componentDidMount(){
        this.loadForm(this.props.params.id)
        if(this.isActionUpdate()){
            if (this.getQuery().id /*id do modelo passado por paramento*/) {
                this.selected = true; 
                
                getDadosFixosCertificado(this.getQuery().id, res => {
                    const dados = res.data
                    const bgImagem = `data:image/png;base64,${dados.bgImagemByte}`
                    this.setState({
                        certificado: {
                            tituloModelo: dados.tituloModelo,
                            formato: dados.formato,
                            bgImagem,
                            conteudo: dados.conteudo
                        },
                        idCampo: dados.idCampo,
                        idFormulario: dados.idFormulario,
                        bgFundo64: bgImagem,
                        bgName: dados.bgImagem,
                        temCertificadoLiberado: dados.temCertificadoLiberado
                    })

                    this.formatoCertificado(dados.formato)
                    this.setBackgroundImage(bgImagem)
                }, error => {
                    this.notifyError('Erro ao recuperar Modelo!', error)
                    this.redirect(`/admin/formulario/${this.props.params.id}/certificado`)
                })

                this.forceUpdate();
            } else {this.redirect(`/admin/formulario/${this.props.params.id}/certificado`)}
        }
    }
    
    loadForm(formID){
        buscarFormulario(formID, res => {
            const formulario = res.data;
            let itens = JSON.parse(formulario.formEditavel).itens.map(i => {
                return i.pergunta
            })
            this.setState({itensFormCertificado: itens})
            // const schema = JSON.parse(formulario.formSchema).schema;

            // // Define o modelo que texto do status na tela
            // const statusTitulo = formulario.status ?  'ABERTO' : 'FECHADO';
            // const statusCor = formulario.status ? 'green' : 'red';
            // const status = <small className={`label ${statusCor}`}>[{statusTitulo}]</small>;

            // this.setState({...this.state, formulario: formulario, schema: schema, status: status});
            this.options = this.getListaDeCamposComCertificado(formulario.formEditavel);
            this.forceUpdate();
        }, 
        error => {
            this.notifyError('Erro ao carregar Formulário!', '')
        })
    }

    getListaDeCamposComCertificado(formEditavel){
        const formEditavelJson = JSON.parse(formEditavel);
        const itens = formEditavelJson.itens;
        let camposComCertificado = [];
        if(formEditavelJson.temCertificado){
            camposComCertificado.push({key: 0, value: 0, text: formEditavelJson.titulo+' - Certificado do Evento'})
        }
        itens.forEach(item => {
            if(item.certificado){
                camposComCertificado.push({key: item.id, value:item.id, text: item.pergunta})
            }
        });
        return camposComCertificado;
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value });

    handleSubmit = e => {
        e.preventDefault();
        let data = {
            ...this.state.certificado, //formato, conteudo, bgImagem, tituloModelo
            idFormulario: this.state.idFormulario, 
            idCampo: this.state.idCampo
        }

        if (this.isActionUpdate() && this.getQuery().id /*id do modelo passado por paramento*/) {
            data.pathImagem = this.state.bgName
            atualizarDadosCertificado(data, this.getQuery().id, res => {
                this.notifySucess("Sucesso", "Modelo de Certificado atualizado com sucesso.")
                this.redirect(`/admin/formulario/${this.props.params.id}/certificado`); 
            }, error => {
                this.notifyError("Erro", error)
            })
        } else {   
            salvarDadosCertificado(data, res => {
                this.notifySucess("Sucesso", "Modelo de Certificado cadastrado com sucesso.")
                this.redirect(`/admin/formulario/${this.props.params.id}/certificado`); 
            }, error => {
                this.notifyError("Erro", error)
            })
        }
        
    };

    downloadModelo = e => {
        e.preventDefault();
        downloadModeloCertificado(this.getQuery().id, res => {
            downloadFileLink(res.data, "Certificado")
        }, error => {
            this.notifyError("Erro", error)
        })
    }

    onChangeOptions(e, data){
        e.preventDefault();
        this.selected = true;
        this.forceUpdate();
        this.setState({...this.state, idCampo: data.value});
    }

    isSelectedItem(){
        return this.selected;
    }

    disabled(){
        return !(this.novoDadoCertificado);
    }

    

    // certificado
    onCertificadoChange = (e, { name, value }) => {
        this.setState({certificado: update(this.state.certificado, {$merge: {[name]: value}})});
    }
    onEditorChange = (data) => {
        this.setState({certificado: update(this.state.certificado, {$merge: {conteudo: data}})});
    }
    onChangeFormatoCertificado(e, data){
        this.onCertificadoChange(e, {name: 'formato', value: data.value})
        // this.setState({certificado: update(this.state.certificado, {$merge: {formato: data.value}})});
        
        this.formatoCertificado(data.value)

    }

    formatoCertificado(value){
        if(value === 'portrait'){
            $("#certificadoConteudo").removeClass('landscape')
            $("#certificadoConteudo").addClass('portrait')
        } else {
            $("#certificadoConteudo").removeClass('portrait')
            $("#certificadoConteudo").addClass('landscape')
        }
    }

    getImageAction = (arquivo, base64) =>{
        this.setState({
            certificado: update(this.state.certificado, {$merge: {bgImagem: base64}}),
            bgFundo64: base64
        });
        
        this.setBackgroundImage(base64)

    }

    setBackgroundImage = (base64) => {
        $(".certificadoConteudo .trumbowyg-editor").css('background-image', 'url(' + base64 + ')')
    }

    getIconButton(){
        // adiciona botão @ no inicio das opções do richtext
        $(".trumbowyg-button-pane").prepend("<div class='trumbowyg-button-group '><button type='button' class='trumbowyg-tagcertificado-button trumbowyg-open-dropdown trumbowyg-active' title='Tag Certificado' tabindex='-1'>@</button></div>")
    }

    getTagOptions(){        
        // adiciona oções para quando clicar no botão @ ficar visivel
        let content = "<div class='trumbowyg-dropdown-tagcertificado trumbowyg-dropdown trumbowyg-fixed-top' data-dropdown='tagcertificado' style='position: absolute; top: 35px; left: 0px; display: none;'> "
        
        if(this.state.itensFormCertificado.length > 0){
            this.state.itensFormCertificado.forEach(i => {
                content += `<button type='button' class='trumbowyg-nome-dropdown-button' tag-property='${i}'>${i}</button>`
            })
        }
        
        content += "</div>"
        $(".trumbowyg-box").append(content) 

        // torna as opções visivel
        $(".trumbowyg-tagcertificado-button").click(function(e){
            $(".trumbowyg-dropdown-tagcertificado").css("display", "block")
            e.stopPropagation(); 
        });

        // da display none quando esta visivel ao clica em algum canto
        $(window).click(function() {
            if($(".trumbowyg-dropdown-tagcertificado")[0] 
              && $(".trumbowyg-dropdown-tagcertificado")[0].style.display === "block"){
                $(".trumbowyg-dropdown-tagcertificado").css("display", "none")
            }
        });

    }

    tagCertificadoButtonAction(){
        const that = this
        $(".trumbowyg-nome-dropdown-button").click(function(e){
            
            // pegando o valor da tag-property e o valor do button e criando tag html
            const tagValue = $(e.target).attr('tag-property')
            const value = $(e.target).text()
            let html = "<span class='campocertificado' campo-certificado='" + tagValue + "'>&lt;&lt; " + value + " &gt;&gt;</span>"

            let sel, range, expandedSelRange;

            // verifica se o nagevador tem suporte a getSelection
            // para inserir a tag no meio do conteudo
            if (window.getSelection) {
                sel = window.getSelection();
                // validando todas as possiveis origens do avento
                // e verificando se eles vem de dentro da div com class "trumbowyg-editor"
                let origin = sel.anchorNode.className 
                let origin1 = null, origin2 = null, origin3 = null, origin4 = null, origin5 = null, origin6 = null, origin7 = null, origin8 = null
                // entre try/catch para evitar nulls
                try {origin1 = sel.anchorNode.offsetParent.className} catch (e) {}
                try {origin2 = sel.baseMode.parentElement.offsetParent.className} catch (e) {}
                try {origin3 = sel.extentNode.parentElement.offsetParent.className} catch (e) {}
                try {origin4 = sel.focusNode.parentElement.offsetParent.className} catch (e) {}
                try {origin5 = sel.anchorNode.parentElement.className} catch (e) {}
                try {origin6 = sel.anchorNode.parentNode.className} catch (e) {}
                try {origin7 = sel.baseMode.parentElement.className} catch (e) {}
                try {origin8 = sel.baseMode.parentNode.className} catch (e) {}

                if(origin === "trumbowyg-editor" || origin1 === "trumbowyg-editor" || origin2 === "trumbowyg-editor" 
                    || origin3 === "trumbowyg-editor" || origin4 === "trumbowyg-editor" || origin5 === "trumbowyg-editor" 
                    || origin6 === "trumbowyg-editor" || origin7 === "trumbowyg-editor" || origin8 === "trumbowyg-editor"){
                    
                    // inserindo html onde o focus estava
                    if (sel.getRangeAt && sel.rangeCount) {
                        range = window.getSelection().getRangeAt(0);
                        // texto selecionado, caso queira colocar tag entre texto
                        // mudar html colocando o valor de selectedText entre as tags
                        //let selectedText = range.toString(); 
                        expandedSelRange = range.cloneRange();
                        range.collapse(false);
                        
                        // Range.createContextualFragment() would be useful here but is
                        // non-standard and not supported in all browsers (IE9, for one)
                        let el = document.createElement("div");
                        el.innerHTML = html;
                        let frag = document.createDocumentFragment(), node, lastNode;
                        while ( (node = el.firstChild) ) {
                            lastNode = frag.appendChild(node);
                        }
                        range.insertNode(frag);
                        
                        // Preserve the selection
                        if (lastNode) {
                            expandedSelRange.setEndAfter(lastNode);
                            sel.removeAllRanges();
                            sel.addRange(expandedSelRange);
                        }

                        //setState
                        that.onEditorChange($("#react-trumbowyg").html())

                    }

                } 

            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                expandedSelRange = range.duplicate();
                range.collapse(false);
                range.pasteHTML(html);
                expandedSelRange.setEndPoint("EndToEnd", range);
                expandedSelRange.select();
            }

        })
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if( this.isSelectedItem() && $(".trumbowyg-tagcertificado-button").length === 0 && this.state.itensFormCertificado.length > 0){
            this.getIconButton()
            this.getTagOptions()
            this.tagCertificadoButtonAction()
        } 
    }

    isFormValid(){

        if(this.state.temCertificadoLiberado) return true

        if(this.isSelectedItem() && this.state.certificado.tituloModelo.length > 0
            && this.state.certificado.conteudo.length > 0 && this.state.certificado.bgImagem !== undefined
            && this.state.certificado.bgImagem !== null && this.state.certificado.bgImagem.length > 0){
                return false
        } 

        return true
    }

    getActions(){
        return(
            <div>
                {this.isActionUpdate() && (
                    <ButtonFields className="m-r" content="Baixar Modelo" button="colored" onClick={this.downloadModelo} />
                )}
                <ButtonFields content="Salvar" type="submit" disabled={this.isFormValid()} button="colored" onClick={this.handleSubmit} />
            </div>
        )
    }

    messageTemCertificadoLiberado(){
        if(this.state.temCertificadoLiberado)
            return (
                <Message type={'warning'}
                        title={'Não é possível editar'}
                        message={"O modelo selecionado possui Certificado liberado para inscritos."}/>
            )
    }

    render() {
        const ratioX = this.certificadoRatio[this.state.certificado.formato].x
        const ratioY = this.certificadoRatio[this.state.certificado.formato].y
        return (
            <div>
                {this.messageTemCertificadoLiberado()}
                <Card titulo='Modelo de Certificado' actions={this.getActions()}>

                    <SelectField
                        name="enable" 
                        label='Certificados do formulário' 
                        placeholder='Certificados do formulário'
                        options={this.options}
                        value={this.state.idCampo}
                        onChange={this.onChangeOptions}
                        disabled={this.isActionUpdate()}
                        required invalidMessage="O campo é de preenchimento obrigatório"
                    />

                    {this.isSelectedItem() &&  
                        <div>
                            <InputField width={12} 
                                        name="tituloModelo" 
                                        label='Titulo para o Modelo'
                                        value={this.state.certificado.tituloModelo} 
                                        onChange={this.onCertificadoChange}
                                        invalidMessage="O campo é de preenchimento obrigatório"
                                        required
                                        disabled={this.state.temCertificadoLiberado}
                                        />


                            <SelectField required invalidMessage="O campo é de preenchimento obrigatório"
                                name="formato certificado" 
                                label='Formato do Certificado' 
                                placeholder='Formato do Certificado'
                                value={this.state.certificado.formato}
                                options={this.formatosCertificado}
                                onChange={this.onChangeFormatoCertificado}
                                disabled={this.state.temCertificadoLiberado}
                            />
                            
                            <UploadCroppedImage
                                label="Selecione uma imagem para o fundo do certificado."
                                setModalConfig={this.displayModal}
                                getImageAction={this.getImageAction}
                                tituloModal={'Recortar Imagem'}
                                fileName={"bgImagem"}
                                hasPreview={this.state.bgFundo64}
                                ratioX={ratioX}
                                ratioY={ratioY}
                                preview
                                name="bgImagem"
                                width={1920}
                                height={1080}
                                required
                            />

                            <Fields width={12} name="corpo" label='Conteúdo' required>
                                <div id="certificadoConteudo" className="certificadoConteudo landscape">
                                    <RichTextEditor data={this.state.certificado.conteudo} onChange={this.onEditorChange}/>

                                    <div className="link-validacao"> Area reservada para link de validação.</div>
                                </div>
                            </Fields>

                        </div>  
                    }
                </Card>

                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/view/formulario/list/tabs/NovoModeloCertificado.js